import React from 'react';
import { Bot, CheckCircle2, Clock, Inbox, Timer } from 'lucide-react';
import { StatCard } from './StatCard';
import { fmtNum } from './kpiUtils';
import { fmtHoras, fmtPct } from './atencionUtils';

// B2: tarjetas (sin tickets de sistema).
export const AtencionTarjetas = ({ r = {} }) => (
  <div className="mb-6 grid grid-cols-2 gap-4 lg:grid-cols-5">
    <StatCard label="Tickets" value={fmtNum(r.tickets)} icon={Inbox} accent="#0284c7" testId="atencion-kpi-tickets" />
    <StatCard label="Abiertos" value={fmtNum(r.abiertos)} icon={Clock} accent="#f59e0b" testId="atencion-kpi-abiertos" />
    <StatCard label="SLA de resolución cumplido" value={fmtPct(r.sla_cumplido_pct)} icon={CheckCircle2} accent="#10b981" testId="atencion-kpi-sla" />
    <StatCard label="Mediana de resolución" value={fmtHoras(r.mediana_resolucion_h)} icon={Timer} accent="#6366f1" testId="atencion-kpi-mediana" />
    <StatCard label={`Resolución del bot (${fmtNum(r.bot_resueltos)}/${fmtNum(r.bot_tickets)})`} value={fmtPct(r.bot_tasa_pct)}
      icon={Bot} accent="#16a34a" testId="atencion-kpi-bot" />
  </div>
);
